import { createFileRoute } from "@tanstack/react-router"
import { createIssueTypeViewStaticData } from "src/views/CreateIssueTypeView/constants"
import { CreateIssueTypeView } from "src/views/CreateIssueTypeView/CreateIssueTypeView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/issue-types/create")({
	component: CreateIssueTypeView,
	staticData: createIssueTypeViewStaticData,
})
